module.exports = __webpack_public_path__ + "img/ppr-systems-buttons-add.40f76b4b.svg";